import { IAuthenticationProviderSelectorModel } from '../directives/tbAuthenticationProviderSelector';
import { IBulkImportFormControls, uploadCsvAction } from '../directives/tbBulkImportUsersForm';
import { ILongRunningAction } from '../models/ILongRunningAction';
import { Module } from '../Module';
import { IBulkImportUsersFromCsvResult } from '../ServerApi/types/BulkImportUsersFromCsvResponse';
import { AddUsersOptionsAction, UserAddedEvent } from '../services/AddUsersOptionsAction';
import { HelpService } from '../services/HelpService';
import { IModalScope } from '../services/ModalService';
import { ErrorReason } from '../services/ServerService';
import { ToasterService, ToastType } from '../services/ToasterService';

export interface IBulkImportUsersDialogScope extends IModalScope {

  percentComplete: number;

  // the URL that we submit the form to
  endpoint: string;
  showAuthSettingSelector: boolean;
  authenticationProviderSelectorModel: IAuthenticationProviderSelectorModel;
  authSetting: string;

  importInProgress: boolean;
  importComplete: boolean;

  form: {
    controls: IBulkImportFormControls
  };

  importFile(): void;
  validateFile(): void;
  canSubmitForm(): boolean;

  importResults: IBulkImportUsersFromCsvResult;

  dialogState: any;
  currentState: BulkImportUsersDialogState;

  closeButtonText(): string;
  csvHelpHref: string;

}

export enum BulkImportUsersDialogState {
  SelectFile,
  ImportInProgress, // will be used to show progress bar
  PreviewComplete,
  ImportComplete
}

export class BulkImportUsersDialogCtrl {

  public static Method = {
    ImportUsersFromCsv: 'importUsersFromCsv',
    ImportServerUsersFromCsv: 'importServerUsersFromCsv'
  };

  public static $inject = [
    '$scope',
    '$translate',
    'RestApiPrefix',
    'method',
    'showAuthSettingSelector',
    'HelpService',
    'ToasterService',
    'AddUsersOptionsAction'
  ];

  constructor(
    private $scope: IBulkImportUsersDialogScope,
    private $translate: ng.translate.ITranslateService,
    apiPrefix: string,
    method: string, // BulkImportUsersDialogCtrl.Method
    showAuthSettingSelector: boolean,
    HelpService: HelpService,
    private toaster: ToasterService,
    AddUsersOptionsAction: AddUsersOptionsAction
  ) {

    $scope.form = { controls: null };

    $scope.currentState = BulkImportUsersDialogState.SelectFile;
    $scope.dialogState = BulkImportUsersDialogState;

    // This is the url that the form is submitted to
    $scope.endpoint = apiPrefix + method;
    $scope.showAuthSettingSelector = showAuthSettingSelector;
    $scope.authenticationProviderSelectorModel = AddUsersOptionsAction.getInitialAuthenticationProviderSelectorModel();
    $scope.authSetting = $scope.authenticationProviderSelectorModel.authSetting;

    $scope.$watch('authenticationProviderSelectorModel.authSetting', (newVal: string, oldVal: string) => {
      if (newVal === oldVal) return;
      $scope.authSetting = newVal;
    });

    $scope.importFile = () => {
      $scope.currentState = BulkImportUsersDialogState.ImportInProgress;
      $scope.percentComplete = 0;
      $scope.form.controls.submitFormForAction(uploadCsvAction.importFile)
        .then(importComplete, importFailed, notifyProgress);
    };

    // TODO: validate is off until server support is done.
    //       this should set the dialog state to PreviewComplete instead of ImportComplete
    $scope.validateFile = () => {
      $scope.form.controls.submitFormForAction(uploadCsvAction.validateFile)
        .then(importComplete, importFailed, notifyProgress);
    };

    $scope.canSubmitForm = () => {
      return $scope.form.controls && $scope.form.controls.canSubmitForm();
    };

    $scope.closeButtonText = () => {
      return $scope.currentState === BulkImportUsersDialogState.ImportComplete
        ? 'done'
        : 'cancel';
    };

    // TODO This token should be in a common contextual help data structure in HelpService
    $scope.csvHelpHref = HelpService.getServerHelpUrlByCategory('adminusers2');

    const notifyProgress = (action: ILongRunningAction) => {
      this.$scope.percentComplete = action.percentComplete;
    };

    const importFailed = (reason: ErrorReason) => {
      this.$scope.close({});
      this.toaster.pop({ type: ToastType.Error, text: this.$translate.instant('addUsersFailed') });
    };

    const importComplete = (longRunningAction: ILongRunningAction) => {
      $scope.currentState = BulkImportUsersDialogState.ImportComplete;
      this.$scope.percentComplete = longRunningAction.percentComplete;
      this.$scope.importResults = longRunningAction.response;
      this.$scope.$emit(UserAddedEvent);
    };

  }

}

Module.instance().controller('BulkImportUsersDialogCtrl', BulkImportUsersDialogCtrl);
